import {
  FormControlLabel,
  type FormControlLabelProps,
  Radio,
  type RadioProps,
  useTheme
} from '@mui/material'
import type { FC } from 'react'

export type MolsonRadioButtonProps = {
  formControlLabelProps: Omit<FormControlLabelProps, 'control'>
  radioBtnProps: RadioProps
  checked?: boolean
  error?: boolean
}

export const MolsonRadioButton: FC<MolsonRadioButtonProps> = ({
  formControlLabelProps,
  radioBtnProps,
  checked,
  error
}) => {
  const theme = useTheme()

  let stateColor = theme.palette.secondary[900]
  if (checked) {
    stateColor = theme.palette.primary.light
  } else if (error) {
    stateColor = theme.palette.primary.error
  }

  return (
    <FormControlLabel
      {...formControlLabelProps}
      control={<Radio {...radioBtnProps} />}
      slotProps={{
        typography: {
          color: stateColor
        }
      }}
      sx={{
        borderWidth: 1,
        borderStyle: 'solid',
        borderColor: stateColor,
        borderRadius: 2,
        padding: 1,
        width: '100%',
        ...formControlLabelProps.sx
      }}
    />
  )
}
